import Image from "next/legacy/image"
import useStore from "components/ui/Context"
import { useEffect, useState } from "react"
import { renderTimeFromNow, renderTime, convertSecondToTimePlay } from "utils/time"
import TypeEvent from "utils/TypeEvent"
import Link from "next/link"
import Tippy from "@tippyjs/react"
import IconStar from "assets/icon/iconStar"

function CardHorizontal({
  is_live,
  name,
  league_name,
  thumbnail_horizontal,
  thumbnail,
  start_time,
  created,
  status,
  duration,
  hideText,
  showTime = false,
  package_type,
  is_monopoly = false,
  is_premium = false,
  type,
  league_id,
  id,
  nextLink,
  type_block,
  customGrid,
  topic_channel_ids,
  card_type,
  isEventCategory
}) {
  const setModalLive = useStore().setModalLive
  const [srcImage, setSrcImage] = useState(thumbnail_horizontal || thumbnail)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 640) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }

    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  function nextPath(e) {
    if (status !== "live" && is_live) {
      e.preventDefault()

      setModalLive({
        show: true,
        info: {
          title: name,
          start_time
        }
      })
    }
  }

  return (
    <div onClick={nextPath}>
      <div
        className={` ${
          customGrid && isMobile
            ? isEventCategory
              ? "flex flex-col gap-4 bg-[#202020] rounded-2xl pb-4"
              : "grid grid-cols-2 gap-4"
            : "relative flex flex-col gap-2.5 max-sm:mb-3"
        } ${type_block === 6 && "max-md:flex-row max-md:items-center"}`}
      >
        <div className="relative wapper__play rounded-xl bg-[#202020]">
          <Link href={nextLink || ""} onClick={nextPath}>
            <div className="fix_img max-md:flex-1">
              <Image
                className="rounded-xl object-cover max-w-full"
                src={srcImage}
                width={isMobile && type_block === 6 ? 176 : 1600}
                height={isMobile && type_block === 6 ? 100 : 900}
                alt={"name"}
                onError={() => setSrcImage("/placeholder_video.svg")}
              />
              {is_premium && (
                <div className="flex items-center gap-1 absolute top-3 left-0 bg-[linear-gradient(to_right,#FF4D00,#F67A36)] py-1 px-2">
                  <IconStar />
                  <span className="text-[#FFEB99] text-xs font-bold">Premium</span>
                </div>
              )}
            </div>
            <div className="layer__play rounded-xl">
              <div className="icon__play">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http:www.w3.org/2000/svg">
                  <path
                    d="M7.30078 7.65618C7.30078 5.43726 9.6747 4.02636 11.6238 5.08689L27.6938 13.8309C29.7298 14.9387 29.7298 17.8616 27.6938 18.9695L11.6238 27.7135C9.6747 28.774 7.30078 27.3631 7.30078 25.1442V7.65618Z"
                    fill="#FAFAF9"
                  />
                </svg>
              </div>
            </div>
          </Link>
          {status === "live" && is_live && !topic_channel_ids && (
            <div
              className={`flex items-center justify-center absolute bottom-2 right-3 ${
                isEventCategory ? "bg-[#5F1515] rounded-md py-[3px] px-2" : "bg-[#C02525] rounded px-1.5 py-1"
              }`}
            >
              {isEventCategory && <div className="w-2 h-2 bg-[#C02525] rounded-full mr-[5px]"></div>}
              <div
                className={`text-[#F4F4F8] ${
                  isEventCategory ? "font-medium text-[12px] leading-[16px] tracking-normal" : "font-normal text-sm"
                }`}
              >
                Trực tiếp
              </div>
            </div>
          )}
          {!is_live && type === TypeEvent.VOD && (
            <div className="font-medium py-0.5 px-2 absolute text-xs min-[1440px]:text-sm bottom-2 right-2 bg-[#13131385] rounded-lg">
              <div>{convertSecondToTimePlay(duration)}</div>
            </div>
          )}
        </div>
        {!hideText && (
          <>
            <div className="flex flex-col max-md:flex-1 max-md:gap-2 max-sm:justify-center">
              <Link href={`/video?id=${id}&type=${type}`} onClick={nextPath}>
                <Tippy content={name}>
                  <div
                    className={`line-clamp-2 bottom-0 left-0 w-full font-medium text-ellipsis text-sm md:text-base ${
                      isEventCategory ? "px-4 pt-2" : ""
                    }`}
                  >
                    {name}
                  </div>
                </Tippy>
              </Link>
              {isMobile && type_block === 6 && (
                <Link href={`/league?id=${league_id}`}>
                  <span className="text-[#FAFAF9] bg-[#0C3B80] rounded-[24px] py-1 px-2 w-fit text-xs leading-[17px] line-clamp-1 font-normal hover:bg-primary hover:text-[#FAFAF9]">
                    {league_name}
                  </span>
                </Link>
              )}
            </div>
            {showTime && (
              <time dateTime={new Date(start_time)} className="text-primary-dark text-xs">
                {is_live ? renderTime(start_time) : renderTimeFromNow(created)}
              </time>
            )}
          </>
        )}
      </div>
    </div>
  )
}
export default CardHorizontal
